export class Bank {
    Id: string;
    Name: string;
}
export class NetBanking {
    baseUrl: string;
    payload: string;
    signature: string;
}
export class ZestBank {
    id: string;
    zestInstitutionCode: string;
    perfiosInstitutionId: string;
    name: string;
    instituionType: string;
    addressAvailable: boolean;
    isStatement: boolean;
    isNetbanking: boolean;
    bankStatementFetchInstructions: BankInstructions[];
}
export class BankInstructions {
    alternateName: string;
    category: string;
    instruction: string;
    perfiosInstitutionId: string;
}
export enum CheckoutOptions {
    Netbanking,
    Statements
}
export class RecommendedBank {
    id: string;
    perfiosInstitutionId: string;
    zestInstitutionCode: string;
    name: string;
    image: string;
    label: string;
    constructor(id: string, perfiosInstitutionId: string, zestInstitutionCode: string, name: string, image: string, label: string) {
        this.id = id;
        this.perfiosInstitutionId = perfiosInstitutionId;
        this.zestInstitutionCode = zestInstitutionCode;
        this.name = name;
        this.image = image;
        this.label = label;
    }
}
export const RecommendedBankList: RecommendedBank[] = [
    {
        id: '61',
        perfiosInstitutionId: '35',
        zestInstitutionCode: 'SBI',
        name: 'State Bank of India',
        image: '../../assets/images/bank-logo/Sbi.png',
        label: 'SBI'
    }, {
        id: '8',
        perfiosInstitutionId: '2',
        zestInstitutionCode: 'UTIB',
        name: 'Axis Bank',
        image: '../../assets/images/bank-logo/Axis.png',
        label: 'Axis'
    }, {
        id: '31',
        perfiosInstitutionId: '20',
        zestInstitutionCode: 'HDFC',
        name: 'HDFC Bank',
        image: '../../assets/images/bank-logo/Hdfc.png',
        label: 'HDFC'
    }, {
        id: '33',
        perfiosInstitutionId: '22',
        zestInstitutionCode: 'ICIC',
        name: 'ICICI Bank',
        image: '../../assets/images/bank-logo/Icici.png',
        label: 'ICICI'
    }, {
        id: '45',
        perfiosInstitutionId: '28',
        zestInstitutionCode: 'KKBK',
        name: 'Kotak Mahindra Bank',
        image: '../../assets/images/bank-logo/Kotak.png',
        label: 'Kotak'
    }

];

export const latestRecommendedBankList: RecommendedBank[] = [
  ...RecommendedBankList,
    {
        id: '11',
        zestInstitutionCode: 'BKID',
        perfiosInstitutionId: '9',
        name: 'Bank of Baroda',
        image: '../../assets/images/bank-logo/bob.png',
        label: 'Bank of Baroda',
    },
    {
        id: '52',
        zestInstitutionCode: 'PUNB',
        perfiosInstitutionId: '30',
        name: 'Punjab National Bank',
        image: '../../assets/images/bank-logo/pnb.png',
        label: 'PNB',
    },
    {
        id: '15',
        zestInstitutionCode: 'CNRB',
        perfiosInstitutionId: '11',
        name: 'Canara Bank',
        image: '../../assets/images/bank-logo/canara.png',
        label: 'Canara bank',
    },
    {
        id: '73',
        zestInstitutionCode: 'UBIN',
        perfiosInstitutionId: '43',
        name: 'Union Bank of India',
        image: '../../assets/images/bank-logo/union bank.png',
        label: 'Union bank',
    },
];
